import React, { Fragment, useState } from 'react';
import {SzButton, SzInput, SzModal} from '@suezenv/react-theme-components'
import {ISaveFilterModal} from "../../../../../type/signal.type";
import '../signal-advanced-filter.scss';
import { useTranslationWithPrefix } from "../../../../../hooks/translation";;

export const SaveFilterModal : React.FC <ISaveFilterModal>= ({
	setShowSaveModal,
	showSaveModal,
	saveNewFavoriteFilters
}) => {
	const trans = useTranslationWithPrefix("signalement", "form_filter");
	const [favoriteFilterLabel, setFavoriteFilterLabel] = useState<string>("");

	return (
		<Fragment>
			<SzModal
				border="smooth"
				title={trans('advanced_filters.new_filter_title')}
				size="sm"
				centered={true}
				backdrop={'static'}
				show={showSaveModal}
				className={'modals-favorite-filter'}
			>   
				<SzInput
					placeholder={trans('advanced_filters.new_filter_label')}
					value={favoriteFilterLabel}
					onChange={e => setFavoriteFilterLabel(e.target.value)}
				/>
				<div className="d-flex justify-content-between mt-3">
					<SzButton variant="tertiary" className="mr-2" onClick={() => setShowSaveModal(false)}>
						{trans('advanced_filters.cancel')}
					</SzButton>
					<SzButton
						variant="secondary"
						isDisabled={favoriteFilterLabel.trim() === "" ? true : false}
						onClick={() => {
							saveNewFavoriteFilters(favoriteFilterLabel);
							setShowSaveModal(false);
						}}
					>
						{trans('advanced_filters.save')}
					</SzButton>
				</div>
			</SzModal>
		</Fragment>
	);
};

export default SaveFilterModal;